import { useRef, useState } from 'react'
import FAQBasedOnQuery from './faqBasedOnQueryType'
import FAQSearch from './faqSearch'
import FAQs from './faqs'
import { useSelector } from 'react-redux'
import CMSWidgetModal from '../../CMSWidget/cmsWidgetModal'
import CMSfaq from '../../CMSWidget/CMSfaq/cmsFAQ'
import { primary_color } from '../../../Helper/uiHelper'
import Loader from 'react-loaders'

const FAQwidget = ({ data, widget_uuid, searchData }) => {
  const [searchValue, setSearchValue] = useState()
  const [modalPosition, setModalPosition] = useState()
  const [loading, setLoading] = useState(false)

  const sectionRef = useRef(null)
  const editMode = useSelector((state) => state.CMS.editMode)

  const handleSectionClick = () => {
    if (!editMode) return
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect()
      setModalPosition({
        top: 200,
        // left: 200, // Align left edge with parent element
        width: '100%',
      })
    }
  }
  const onCloseCMSModal = () => {
    let element = sectionRef?.current
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
    }
    setModalPosition(null)
  }

  const heading = data?.find((item) => item?.component_name === 'heading')?.value
  const subHeading = data?.find((item) => item?.component_name === 'sub_heading')?.value
  const additionalInfo = data?.find((item) => item?.component_name === 'additional_setting')?.value
  const additionalSetting = additionalInfo && JSON.parse(additionalInfo)

  return (
    <div className='my-5 content-widget' ref={sectionRef} onClick={handleSectionClick}>
      {heading && (
        <h2 className='h2 text-center font-weight-bold' style={{ color: primary_color }}>
          {heading?.replace(/<[^>]*>/g, '')}
        </h2>
      )}
      {subHeading && (
        <div className='p text-center text-muted mb-5' style={{ color: primary_color, fontWeight: 100 }}>
          {subHeading?.replace(/<[^>]*>/g, '')}
        </div>
      )}
      <div className='d-flex justify-content-center mb-5'>
        <div style={{ maxWidth: '30rem', width: '100%' }}>{/* <FAQSearch searchValue={searchData} setSearchValue={setSearchValue} /> */}</div>
      </div>
      <div>
        {!additionalSetting?.query_as_heading && !additionalSetting?.query_type_as_heading ? (
          <FAQs searchValue={searchData} additionalSetting={additionalSetting} loading={loading} setLoading={setLoading} />
        ) : (
          <FAQBasedOnQuery additionalSetting={additionalSetting} searchValue={searchData} loading={loading} setLoading={setLoading} />
        )}
      </div>

      {modalPosition && (
        <CMSWidgetModal sx={{ ...modalPosition }} toggleModal={() => onCloseCMSModal()}>
          <CMSfaq data={data} widget_uuid={widget_uuid} toggleModal={() => onCloseCMSModal()} />
        </CMSWidgetModal>
      )}
    </div>
  )
}

export default FAQwidget
